import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { userActions } from "./actions";
import { UserRole, UserState } from "./types";
import { USER_ROLE } from "../../constants/app";

const initialState: UserState = {
  users: null,
};

export function UserReducer(state = initialState, action: Action): UserState {
  if (isType(action, userActions.fetchUsers.done)) {
    return {
      ...state,
      users: action.payload.result.data.map((user) => ({
        id: user.id,
        name: `${user.last_name} ${user.first_name}`,
        firstName: user.first_name,
        lastName: user.last_name,
        clientName: user.customer_name,
        groupName: user.group_name,
        role:
          user.role === USER_ROLE.SYSTEM_ADMINISTRATOR
            ? UserRole.Admin
            : user.role === USER_ROLE.USER
              ? UserRole.User
              : UserRole.GroupAdmin,
        systemPermissions: user.system_permission,
        validPeriod: {
          from: new Date(user.valid_from),
          to: new Date(user.valid_to),
        },
        lastLogin: user.last_login ? new Date(user.last_login) : null,
      })),
    };
  }

  if (isType(action, userActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
